import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";

const AddNewReportCategory = ({ getLupReportCategorysData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [category, setCategory] = useState("");
  let { studyId } = useParams();

  const addNewLupReportCategory = async () => {
    let userData = {}
    setButtonLoader(true)
    userData.name = category
    userData.studyId = studyId
    let data = await studyEDCLupReportingServices.addNewLupReportCategory(userData)
    if (data?.statusCode === 200) {
      getLupReportCategorysData()
      setCategory("")
    }
    setButtonLoader(false)
  }

  return (
    <>
      <div className="p-2">
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Category Name{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            className="fontSize12"
            placeholder="Enter Category"
            onChange={(e) => setCategory(e.target.value)}
            value={category}
          />
        </Form.Group>
        <div className="text-end">
          <button
            onClick={addNewLupReportCategory}
            disabled={!category || buttonLoader}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add Category"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddNewReportCategory;
